module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/sec01_pc_20cb71f75aa6699f40697cd88e88ca76.jpg";